import PropTypes from 'prop-types';

const PricePatchType = PropTypes.shape({
  name: PropTypes.string,
});

export default PricePatchType;



// WEBPACK FOOTER //
// ./client/app/shared/types/pricePatch.js